import React, { memo, useCallback, useEffect, useState } from 'react'
import { ScrollArea } from '@mantine/core'
import { useAppEx } from '@vt/hooks'
import { Tree } from '@ow/comps'
import { fetchOrgData } from '@vt/apis/lib-ex/v2/orgs'
import { pick } from 'lodash-es'
import UserList from './userList'

const Users = function ({ value, onChange, onUserFilter }) {
  const [orgData, setOrgData] = useState([])
  const [orgId, setOrgId] = useState()

  const { appId } = useAppEx((x) => pick(x, ['appId']))

  const onSelect = useCallback((key, { node, selected }) => {
    if (selected) {
      const { id } = node.extData
      setOrgId(id)
    } else {
      setOrgId()
    }
  }, [])

  const setExtData = useCallback((item) => ({ id: item.id }), [])

  useEffect(() => {
    fetchOrgData(appId).then((res) => {
      setOrgData(res)
    })
  }, [])

  return (
    <div className="flex gap-2 overflow-hidden" style={{ height: '405px' }}>
      <div className="w-1/5 border-r flex flex-col gap-4">
        <div className="">组织列表</div>
        <ScrollArea className="flex-1">
          <div className="pr-2 pb-3">
            <Tree
              data={orgData}
              onSelect={onSelect}
              setExtData={setExtData}
              label="title"
              height="100%"
            />
          </div>
        </ScrollArea>
      </div>
      <div className="pl-4 w-4/5 overflow-y-auto">
        <UserList
          orgId={orgId}
          value={value}
          onChange={onChange}
          onUserFilter={onUserFilter}
        />
      </div>
    </div>
  )
}

export default memo(Users)
